import { LitElement, html, css } from 'lit'
import { customElement } from 'lit/decorators.js'

/**
 * See 'ZapticDeleteIcon.stories.tsx' for an example of how to use this component.
 */
@customElement('zaptic-delete-icon')
export class DeleteIcon extends LitElement {
    static styles = css`
        :host {
            display: flex;
        }

        svg {
            cursor: pointer;
            width: 100%;
            height: 100%;
        }

        svg:focus {
            outline: none;
        }

        svg:hover circle {
            fill: var(--grey3);
        }
    `

    render() {
        return html`
            <svg tabindex="0" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="7" fill="#B2C3DB" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.07299 5.1707C5.8454 4.9431 5.47406 4.9431 5.24647 5.1707L5.1707 5.24647C4.9431 5.47406 4.9431 5.8454 5.1707 6.07299L7.09771 8L5.1707 9.92701C4.9431 10.1546 4.9431 10.5259 5.1707 10.7535L5.24647 10.8293C5.47406 11.0569 5.8454 11.0569 6.07299 10.8293L8 8.90229L9.92701 10.8293C10.1546 11.0569 10.5259 11.0569 10.7535 10.8293L10.8293 10.7535C11.0569 10.5259 11.0569 10.1546 10.8293 9.92701L8.90229 8L10.8293 6.07299C11.0569 5.8454 11.0569 5.47406 10.8293 5.24647L10.7535 5.1707C10.5259 4.9431 10.1546 4.9431 9.92701 5.1707L8 7.09771L6.07299 5.1707Z"
                    fill="white"
                />
            </svg>
        `
    }
}
